// The map view lives in the URL hash ("#map=13/50.08310/14.42000"), the way OSM
// does it. That makes the view survive a refresh, work with back/forward, and be
// shareable — a plain localStorage copy would only do the first of those.

const RE = /^#map=(\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)\/(-?\d+(?:\.\d+)?)$/

/**
 * @param {string} hash e.g. "#map=13/50.0831/14.42"
 * @returns {{zoom:number, lat:number, lng:number}|null} null when absent/invalid
 */
export function parseMapHash(hash) {
  const m = RE.exec(String(hash || ''))
  if (!m) return null
  const zoom = Number(m[1])
  const lat = Number(m[2])
  const lng = Number(m[3])
  if (![zoom, lat, lng].every(Number.isFinite)) return null
  if (zoom < 0 || zoom > 22) return null
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null
  return { zoom, lat, lng }
}

/** Inverse of parseMapHash. ~1 m precision is plenty and keeps the URL short. */
export function formatMapHash({ zoom, lat, lng }) {
  const z = Math.round(zoom * 10) / 10
  return `#map=${z}/${lat.toFixed(5)}/${lng.toFixed(5)}`
}
